export class Cookies {

	/**
	 * Constructor for the JG cookie utility class
	 * @param {string} analyticsCookieName
	 * @paran {object} cookieSource - for unit testing
	 */
	constructor(analyticsCookieName, cookiesSource = null) {
		this._analyticsCookieName = analyticsCookieName || '';
		this._cookiesSource = cookiesSource;
		this._cookies = null;
	}

	/**
	 * for a given JG cookie convert it's content
	 * into an object (with the appropriate keys/values)
	 * @returns {object}
	 */
	cookieToObject(cookieName) {
		const _cookies = this.cookies;
		let _cookie = null;
		let _cookieValues = {};
		_cookie = _cookies[cookieName];
		if (_cookie) {
			_cookie.split('&').forEach(part => {
				let _keyVal = part.split('=');
				_cookieValues[_keyVal[0]] = _keyVal[1];
			});
		}
		return _cookieValues;
	}

	/**
	 * 'Getter' for the cookies source.
	 * @description This is primarily here for testing
	 * purposes. Think what yo get from 'document.cookie'
	 * @returns {string}
	 */
	get cookiesSource() {
		if (this._cookiesSource === null) {
			this._cookiesSource = document.cookie;
		}
		return this._cookiesSource;
	}

	/**
	 * 'Getter' for our cookies
	 * @returns {object} key/value pairs
	 */
	get cookies() {
		if (this._cookies === null) {
			this._cookies = {};
			for (let _cookie of this.cookiesSource.split('; ')) {
				const _equalsIndex = _cookie.indexOf('=');
				const _key = _cookie.substr(0, _equalsIndex);
				const _value = _cookie.substr(_equalsIndex + 1, _cookie.length);
				this._cookies[_key] = decodeURIComponent(_value);
			}
		}
		return this._cookies;
	}

	/**
	 * 'Getter' for the values/content of the JG
	 * Analytics cookie.
	 * @returns {object} - content split into keys/values
	 */
	get analyticsCookie() {
		return this.cookieToObject(this._analyticsCookieName);
	}

	/**
	 * 'Getter for the values/content of
	 * the JG AB Logged in cookie
	 * @returns {string} - the id this cookie contains
	 */
	get JgAbLoggedInCookie() {
		return (this.cookies.JGABID) ? { value: this.cookies.JGABID.replace('id=', '') } : '';
	}

	/**
	 * 'Getter' for the values/content of
	 * the JG User Metadata cookie
	 * @returns {object}
	 */
	get JgUserMetadataCookie() {
		return this.cookieToObject('JGUserMetadata');
	}

}



// WEBPACK FOOTER //
// ../~/dna-core/components/utils/js/cookies.js